// src/components/invoices/InvoiceHeaderCard.jsx
import React from 'react';
import useInvoiceStore from '../../store/useInvoiceStore';
import useInvoiceCalculator from '../../hooks/useInvoiceCalculator';
import useExchangeStore from '../../store/useExchangeStore';

const InvoiceHeaderCard = ({ locked = false }) => {
  const { activeInvoice, updateActiveInvoiceField } = useInvoiceStore();
  const { calculateAllTotals } = useInvoiceCalculator();
  const { getRate } = useExchangeStore();

  const handleCurrencyChange = (newCurrency) => {
    const rate = getRate(newCurrency);
    // Toplu güncelleme için updateActiveInvoiceField yerine direkt store metodlarını kullanabilirsin
    updateActiveInvoiceField('currency', newCurrency);
    updateActiveInvoiceField('exchangeRate', rate);
    
    if (activeInvoice?.items) {
      calculateAllTotals(activeInvoice?.items || [], rate);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 bg-white p-6 rounded-[2.5rem] text-slate-900 shadow-xl border border-slate-100">
      {/* Fatura Tarihi */}
      <div className="px-4 border-r border-slate-200">
        <label className="text-[10px] font-black text-slate-900 uppercase tracking-widest">Fatura Tarihi</label>
        <input 
          type="date" disabled={locked}
          value={activeInvoice?.date?.split('T')[0] || ''} 
          onChange={e => updateActiveInvoiceField('date', e.target.value)} 
          className="bg-transparent w-full font-bold text-slate-900 outline-none mt-1" 
        />
      </div>

      {/* Vade Tarihi */}
      <div className="px-4 border-r border-slate-200">
        <label className="text-[10px] font-black text-slate-900 uppercase tracking-widest">Vade Tarihi</label>
        <input 
          type="date"
          value={activeInvoice?.dueDate?.split('T')[0] || ''} 
          onChange={e => updateActiveInvoiceField('dueDate', e.target.value)} 
          className="bg-transparent w-full font-bold text-slate-900 outline-none mt-1" 
        />
      </div>

      {/* İşlem Türü */}
      <div className="px-4 border-r border-slate-200">
        <label className="text-[10px] font-black text-slate-900 uppercase tracking-widest">İşlem Türü</label>
        <select disabled={locked}
          value={activeInvoice?.type || 'Sales'} 
          onChange={e => updateActiveInvoiceField('type', e.target.value)} 
          className="w-full bg-transparent font-bold text-slate-900 outline-none mt-1 cursor-pointer"
        >
          <option value="Sales">Satış Faturası</option>
          <option value="Purchase">Alış Faturası</option>
          <option value="SalesReturn">Satış İade</option>
          <option value="PurchaseReturn">Alış İade</option>
        </select>
      </div>

      {/* Döviz & Kur */}
      <div className="px-4">
        <label className="text-[10px] font-black text-slate-900 uppercase tracking-widest">Döviz & Kur</label>
        <div className="flex gap-4 items-center mt-1">
          <select disabled={locked}
            value={activeInvoice?.currency || 'TRY'} 
            onChange={e => handleCurrencyChange(e.target.value)} 
            className="bg-transparent font-bold text-slate-900 outline-none cursor-pointer"
          >
            <option value="TRY">TRY</option>
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
          </select>
          {activeInvoice?.currency !== 'TRY' && (
            <input 
              type="number" disabled={locked}
              step="0.0001"
              value={activeInvoice?.exchangeRate || 1} 
              onChange={e => {
                 const val = parseFloat(e.target.value) || 1;
                 updateActiveInvoiceField('exchangeRate', val);
                 calculateAllTotals(activeInvoice?.items || [], val);
              }} 
              className="bg-slate-50 px-3 py-1 rounded-xl text-sm font-bold outline-none text-slate-900 w-24 border border-slate-200" 
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InvoiceHeaderCard;
